import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CalendarDays } from "lucide-react";
import { toast } from "sonner";
import BijeenkomstDetail from "@/components/bijeenkomsten/BijeenkomstDetail";

// Mijn bijeenkomsten (portaal, voorstel 59-A): komend + reageren + te doen (KAM, notulen). Toont niets als de flag uit staat.
export default function MijnBijeenkomsten() {
  const [d, setD] = useState(null);
  const [detail, setDetail] = useState(null);
  const laad = () => api.get("/bijeenkomsten/mijn").then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { laad(); }, []);
  if (!d?.flag_aan || !d.items?.length) return null;
  const rsvp = async (b, v) => { try { await api.post(`/bijeenkomsten/${b.id}/rsvp`, { rsvp: v }); toast.success("Reactie opgeslagen"); laad(); } catch (e) { toast.error("Reageren mislukt"); } };
  return (
    <Card className="p-4 shadow-none" data-testid="mijn-bijeenkomsten">
      <div className="flex items-center gap-2 mb-2"><CalendarDays className="h-4 w-4 text-orange-600" /><div className="text-sm font-semibold">Mijn bijeenkomsten</div><Badge variant="outline">{d.items.length}</Badge></div>
      <div className="space-y-2">
        {d.items.slice(0, 6).map((b) => (
          <div key={b.id} className="flex items-center gap-2 flex-wrap text-xs border-t pt-2" data-testid={`mijn-bj-${b.id}`}>
            <button className="font-medium hover:underline text-left" onClick={() => setDetail(b.id)}>{b.datum} {b.begintijd || ""} · {b.onderwerp}</button>
            {b.te_doen?.reageren && <span className="flex gap-1 ml-auto">{["kom", "misschien", "kan_niet"].map((v) => <Button key={v} size="sm" variant="outline" className="h-6 px-2" onClick={() => rsvp(b, v)} data-testid={`mijn-bj-rsvp-${v}-${b.id}`}>{v === "kom" ? "Ik kom" : v === "misschien" ? "Misschien" : "Kan niet"}</Button>)}</span>}
            {b.mijn_deelname?.rsvp && !b.te_doen?.reageren && <Badge variant="outline" className="ml-auto">{b.mijn_deelname.rsvp}</Badge>}
            {b.te_doen?.kam && <Badge className="bg-amber-100 text-amber-800">KAM-vragen invullen</Badge>}
            {b.te_doen?.notulen && <Badge className="bg-blue-100 text-blue-800">Notulen bevestigen</Badge>}
          </div>
        ))}
      </div>
      <BijeenkomstDetail id={detail} open={!!detail} onClose={() => { setDetail(null); laad(); }} beheer={false} eigenId={d.employee_id} />
    </Card>
  );
}
